module.exports = "<h1>Signing In... Please wait.</h1>\n"